import {OfferDisplayType} from "../helpers/OfferDisplayType";
import {IOfferDetail} from "../types/IOfferDetail";

export function isOfferForSale(offer: IOfferDetail) {
    return offer.configuration.display_type === OfferDisplayType.FOR_SALE;
}
